module.exports = __webpack_public_path__ + "img/free-piggy.146c432.png";